<template>
  <el-dialog
    :title="titleTrans"
    :visible.sync="centerDialogVisible"
    @close="handleClose"
  >
    <div
      class="form-content"
      style="width:70%;padding-left:20px;"
    >
      <el-form
        ref="dataInfo"
        :model="dataInfo"
        :rules="rules"
        label-width="180px"
      >
        <el-form-item
          v-if="isedit"
          label="编号"
        >
          <span class="value">{{ dataInfo.id }}</span>
        </el-form-item>
        <el-form-item
          label="文本"
          prop="name"
        >
          <el-input v-model="dataInfo.name" />
        </el-form-item>
        <el-form-item
          label="值"
          prop="dicKey"
        ><span
           v-if="isEdit"
           class="value"
         >{{ dataInfo.dicKey }}</span>
          <el-input
            v-else
            v-model="dataInfo.dicKey"
          />

        </el-form-item>
      </el-form>
    </div>
   
    <span
      slot="footer"
      class="dialog-footer"
    >
       <el-button @click="handleClose">取消</el-button>
      <el-button
        type="primary"
        style="margin-left:8px"
            @click="submitForm('dataInfo')"
      >确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addDic } from '@/api/system'
export default {
  // props: ['editData'],
  props: {
    editData: {
      default: {}
    },
    isedit: {
      default: 'false'
    },
    parentId: {
      default: ''
    }
  },
  data() {
    return {
      isEdit: this.isedit,
      dataInfo: this.editData,
      centerDialogVisible: true,
      rules: {
        name: [
          { required: true, min: 1, max: 50, message: '请输入长度在 1到 50 个字符', trigger: 'blur' }
        ],
        dicKey: [
          { required: true, min: 1, max: 50, message: '请输入长度在 1到 50 个字符', trigger: 'blur' }
        ]

      }
    }
  },
  computed: {
    titleTrans() {
      let result = '添加参数'
      if (this.isEdit) {
        result = '编辑参数'
      }
      return result
    }
  },
  mounted() {
    console.log(JSON.stringify(this.isEdit))
  },
  methods: {
    handleClose() {
      this.$emit('handleclose', null)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dataInfo.parentId = this.parentId
          addDic(this.dataInfo).then(res => {
            if (res && res.code == 0) {
              // 刷新父级列表(接口成功回调处理)
              this.$emit('refresh', null)
              this.$emit('handleclose', null)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    postData() {
      console.log(JSON.stringify(this.isEdit))
      if (this.isEdit) {
        alert('编辑啊')
      } else {
        alert('添加')
      }
      // 刷新父级列表(接口成功回调处理)
      this.$emit('refresh', null)
      this.$emit('handleclose', null)
    }
  }
}
</script>
